// Kept as `contact` so existing links to the Webflow page (/discover/datasets#contact) still land on the form.
export const FORM_ANCHOR_ID = 'contact'

export const FORM_ANCHOR_HREF = `#${FORM_ANCHOR_ID}`
